import { Sparepart, SparepartMake, SparepartType } from "@/types";
import { getData, postData, putData, deleteData } from "./axios-service"


function modelMapper(inputSparepart: any): Sparepart {
    const name = inputSparepart.name || "";
    const frenchName = inputSparepart.frenchName || "";
    return {
        id: inputSparepart.id,
        name: name,
        frenchName: frenchName,
        price: inputSparepart.price,
        unitInStock: inputSparepart.unitInStock,
        minUnitInStock: inputSparepart.minUnitInStock,
        reference: inputSparepart.reference,
        notificationEnabled: inputSparepart.notificationEnabled,
        sparepartType: inputSparepart.sparepartType,
        sparepartStatus: inputSparepart.sparepartStatus,
        sparepartMake: inputSparepart.sparepartMake,
        command: inputSparepart.command,
        stockValue: inputSparepart.stockValue,
        displayName: `${name} (${frenchName})`.trim()
    };
}

export function modelMapperArray(inputArray: any[]): Sparepart[] {
    return inputArray.map(modelMapper);
}

export async function getAllSpareparts(): Promise<Sparepart[]> {
    const spareparts = await getData<Sparepart[]>("spareparts");
    return modelMapperArray(spareparts ?? []);
}

export async function fetchFilteredSpareParts(sparePartMakes: SparepartMake[], sparePartTypes: SparepartType[]): Promise<Task[]> {
    const params = new URLSearchParams();

    if (sparePartMakes.length > 0) {
        params.set("sparepart_makes", sparePartMakes.join(","));
    }

    if (sparePartTypes.length > 0) {
        params.set("sparepart_types", sparePartTypes.join(","));
    }

    const query = params.toString();
    const url = query ? `spareparts?${query}` : "spareparts";

    const response = await getData<Sparepart[]>(url);
    return modelMapperArray(response ?? []);
}

export function getSparepartById(id: string): Promise<Sparepart> {
    return getData("spareparts/" + id).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function postSparepart(sparepart: Sparepart): Promise<Sparepart> {
    return postData("spareparts", sparepart).then(
        onSucceed => {
            return modelMapper(onSucceed);
        }
    );
}

export function putSparepart(id: string, sparepart: Sparepart): Promise<any> {
    return putData("spareparts/" + id, sparepart)
}

export function deleteSparepart(ids: string[]): Promise<any> {
    const idsStr = ids.join(',');
    return deleteData("spareparts/" + idsStr)
}

export async function searchForSpareparts(searchQuery: string): Promise<Sparepart[]> {
    const spareparts = await getData<Sparepart[]>("spareparts?" + searchQuery);
    return modelMapperArray(spareparts ?? []);
}